import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appRoutes } from './app.routes';
import { apiUrlInterceptor } from './interceptors/api-url.interceptor';
import { authTokenInterceptor } from './interceptors/auth-token.interceptor';
import { CustomTitleStrategy } from './services/custom-title-strategy.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([apiUrlInterceptor, authTokenInterceptor])),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
  ],
};
